import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { noEditBtn } from '../constants';

const UpdateAlert = ({ title }) => {
  const alertRef = useRef(null);

  useEffect(() => {
    if (alertRef.current) {
      setTimeout(() => {
        alertRef.current?.focus();
      }, 100);
    }
  }, []);

  return (
    <va-alert
      ref={alertRef}
      role="alert"
      tabindex="-1"
      className="vads-u-margin-bottom--1"
      close-btn-aria-label="Close notification"
      disable-analytics="false"
      full-width="false"
      slim
      status="success"
      visible="true"
    >
      <p className="vads-u-margin-y--0">{title} has been updated</p>
    </va-alert>
  );
};

UpdateAlert.propTypes = {
  title: PropTypes.string.isRequired,
};

const PageFieldSummary = props => {
  const {
    renderedProperties,
    defaultEditButton,
    title,
    updatedPage,
    updatedChapterKey,
  } = props;

  if (!renderedProperties) {
    return null;
  }

  const currentChapterKey = props.formContext?.chapterKey;

  return (
    <div className="vads-u-width--full vads-u-justify-content--space-between vads-u-align-items--center">
      {updatedPage && updatedChapterKey === currentChapterKey && (
        <UpdateAlert title={title} />
      )}
      {!noEditBtn.includes(title) && (
        <div className="form-review-panel-page-header-row">
          <h5 className="form-review-panel-page-header">{title}</h5>
          <span>{defaultEditButton({ label: `Edit` })}</span>
        </div>
      )}
      <dl className="review vads-u-margin-top--0 vads-u-margin-bottom--0">
        {renderedProperties.map(
          (question, index) =>
            question && (
              <dl
                className="review-row vads-u-border-top--0 vads-u-margin-top--0 vads-u-margin-bottom--0"
                key={`${question?.props.name} ${index}}`}
              >
                <dt>{question?.props.uiSchema['ui:title']}</dt>
                <dd>{question?.props.formData}</dd>
              </dl>
            ),
        )}
      </dl>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    updatedPage: state.askVA.updatedInReview,
    updatedChapterKey:
      state.form?.pages?.[state.askVA.updatedInReview]?.chapterKey,
  };
}
PageFieldSummary.propTypes = {
  defaultEditButton: PropTypes.func,
  formContext: PropTypes.shape({
    chapterKey: PropTypes.string,
  }),
  renderedProperties: PropTypes.array,
  title: PropTypes.string,
  updatedChapterKey: PropTypes.string,
  updatedPage: PropTypes.string,
};

export default connect(mapStateToProps)(PageFieldSummary);
